import React from 'react'

import { MoreVertical, LucideIcon } from 'lucide-react'

import { Button } from '@/shared/components/atoms/Button'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from '@/shared/components/atoms/Dropdown/Dropdown'

export interface ActionMenuItem {
	label: string
	icon: LucideIcon
	onClick: () => void
	variant?: 'default' | 'destructive'
	disabled?: boolean
}

interface ActionDropdownMenuProps {
	items: ActionMenuItem[]
	triggerIcon?: LucideIcon
	triggerLabel?: string
	triggerClassName?: string
	triggerIconClassName?: string
	align?: 'start' | 'center' | 'end'
	side?: 'top' | 'right' | 'bottom' | 'left'
}

export const ActionDropdownMenu: React.FC<ActionDropdownMenuProps> = ({
	items,
	triggerIcon: TriggerIcon = MoreVertical,
	triggerLabel,
	triggerClassName,
	triggerIconClassName,
	align = 'end',
	side = 'bottom',
}) => {
	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button
					variant="ghost"
					size="icon"
					className={triggerClassName || 'h-8 w-8'}
					onClick={(e) => {
						e.stopPropagation()
					}}
				>
					<TriggerIcon className={triggerIconClassName || 'h-4 w-4'} />
					{triggerLabel && <span className="sr-only">{triggerLabel}</span>}
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align={align} side={side} className="w-56">
				{items.map((item, index) => {
					const Icon = item.icon
					return (
						<DropdownMenuItem
							key={index}
							onClick={(e) => {
								e.stopPropagation() // Prevent triggering parent click events
								item.onClick()
							}}
							variant={item.variant || 'default'}
							disabled={item.disabled}
							className="cursor-pointer"
						>
							<Icon className="h-4 w-4" />
							<span>{item.label}</span>
						</DropdownMenuItem>
					)
				})}
			</DropdownMenuContent>
		</DropdownMenu>
	)
}

export default ActionDropdownMenu
